const REPORT_STEP_PERCENTAGE = 2;
const MIN_REPORT_INTERVAL_MS = 5000;

export const shouldReportProgress = (
  reportedPercentage: number,
  watchedPercentage: number,
  elapsedMsSinceLastReport: number,
): boolean =>
  Math.abs(watchedPercentage - reportedPercentage) >= REPORT_STEP_PERCENTAGE &&
  elapsedMsSinceLastReport >= MIN_REPORT_INTERVAL_MS;
